import { TableDragAndDrop as WSRTableDragAndDrop } from '@wix/wix-style-react-incubator/drag-and-drop';
import { minimalRequiredWdsRuntimeCheck } from '../minimalRequiredWdsRuntimeCheck';
import { CollectionNestedTableDragAndDropContext } from './CollectionTableDragAndDropContext';

if (process.env.NODE_ENV !== 'production') {
  minimalRequiredWdsRuntimeCheck({
    required: '^1.64.1',
    requiredBy: 'Cairo/NestedTableDragAndDrop',
  });
}

export const NestedTableDragAndDrop = {
  ...WSRTableDragAndDrop,
  CollectionNestedTableDragAndDropContext,
};
